(function () {
  const STORAGE_KEY = 'paws_lead_popup_closed_until';
  const SUCCESS_KEY = 'paws_lead_popup_submitted';
  const CLOSED_DAYS = 7;
  const DELAY_MS = 6000;
  const BREVO_FORM_ACTION = (window.PAWS_LEAD_CONFIG && window.PAWS_LEAD_CONFIG.brevoFormAction) || '';
  const BREVO_API_KEY = (window.PAWS_LEAD_CONFIG && window.PAWS_LEAD_CONFIG.brevoApiKey) || '';
  const WAITLIST_LIST_ID = parseInt((window.PAWS_LEAD_CONFIG && window.PAWS_LEAD_CONFIG.waitlistListId) || '9', 10);
  const LEADS_LIST_ID = parseInt((window.PAWS_LEAD_CONFIG && window.PAWS_LEAD_CONFIG.leadsListId) || '8', 10);
  const THANK_YOU_URL = (window.PAWS_LEAD_CONFIG && window.PAWS_LEAD_CONFIG.thankYouUrl) || '';

  async function addContactToBrevo(email, listId, attributes) {
    if (!BREVO_API_KEY) return false;
    try {
      const res = await fetch('https://api.brevo.com/v3/contacts', {
        method: 'POST',
        headers: { 'api-key': BREVO_API_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, listIds: [listId], attributes, updateEnabled: true })
      });
      return res.ok || res.status === 204;
    } catch { return false; }
  }

  async function sendBrevoTransactional(email, templateId, params) {
    if (!BREVO_API_KEY) return;
    try {
      await fetch('https://api.brevo.com/v3/smtp/email', {
        method: 'POST',
        headers: { 'api-key': BREVO_API_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify({ templateId, to: [{ email }], params })
      });
    } catch { /* silencioso */ }
  }

  function parseWaitlistNote(note) {
    const productMatch = note.match(/:\s*([^·]+)\s*·/);
    const variantMatch = note.match(/Variante:\s*([^·]+)/);
    return {
      productName: productMatch ? productMatch[1].trim() : '',
      variantName: variantMatch ? variantMatch[1].trim() : ''
    };
  }

  const blockedPathPattern = /\/(cart|checkout|account|policies|challenge)(\/|$)/;

  if (blockedPathPattern.test(window.location.pathname)) return;
  if (window.localStorage.getItem(SUCCESS_KEY) === 'true') return;

  const closedUntil = Number(window.localStorage.getItem(STORAGE_KEY) || 0);
  if (closedUntil && Date.now() < closedUntil) return;

  const styles = `
    .paws-lead-popup {
      position: fixed;
      inset: 0;
      z-index: 2147483000;
      display: none;
      align-items: center;
      justify-content: center;
      padding: 18px;
      background: rgba(26, 26, 46, 0.46);
    }

    .paws-lead-popup.is-visible {
      display: flex;
    }

    .paws-lead-popup__dialog {
      position: relative;
      width: min(100%, 430px);
      max-height: calc(100vh - 36px);
      overflow: auto;
      border-radius: 16px;
      background: #F8F7FF;
      color: #1A1A2E;
      box-shadow: 0 20px 60px rgba(26, 26, 46, 0.22);
      padding: 30px 24px 24px;
      border: 1px solid rgba(123, 47, 255, 0.14);
      font-family: Inter, var(--font-body-family, sans-serif);
    }

    .paws-lead-popup__close {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 34px;
      height: 34px;
      border: 0;
      border-radius: 999px;
      background: rgba(123, 47, 255, 0.1);
      color: #1A1A2E;
      cursor: pointer;
      font-size: 22px;
      line-height: 1;
    }

    .paws-lead-popup__eyebrow {
      margin: 0 0 10px;
      color: #7B2FFF;
      font-family: Space Grotesk, var(--font-body-family, sans-serif);
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .paws-lead-popup__title {
      margin: 0;
      color: #1A1A2E;
      font-family: Syne, var(--font-heading-family, sans-serif);
      font-size: clamp(28px, 8vw, 38px);
      font-weight: 700;
      line-height: 1.04;
      letter-spacing: 0;
    }

    .paws-lead-popup__copy {
      margin: 14px 0 18px;
      font-size: 15px;
      line-height: 1.55;
    }

    .paws-lead-popup__field {
      width: 100%;
      min-height: 48px;
      border: 1px solid rgba(123, 47, 255, 0.38);
      border-radius: 8px;
      background: #FFFFFF;
      color: #1A1A2E;
      box-sizing: border-box;
      padding: 12px 14px;
      font: inherit;
    }

    .paws-lead-popup__button {
      width: 100%;
      min-height: 50px;
      margin-top: 10px;
      border: 0;
      border-radius: 8px;
      background: #FF5C5C;
      color: #FFFFFF;
      cursor: pointer;
      font-family: "Bebas Neue", Inter, sans-serif;
      font-size: 18px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .paws-lead-popup__button[disabled] {
      cursor: wait;
      opacity: 0.72;
    }

    .paws-lead-popup__legal {
      margin: 10px 0 0;
      color: rgba(26, 26, 46, 0.72);
      font-size: 11px;
      line-height: 1.45;
    }

    .paws-lead-popup__trust {
      display: flex;
      flex-wrap: wrap;
      gap: 10px 16px;
      margin-top: 16px;
      color: #1A1A2E;
      font-size: 12px;
    }

    .paws-lead-popup__message {
      margin: 10px 0 0;
      font-size: 13px;
      line-height: 1.4;
    }

    .paws-lead-popup__message[data-status="success"] {
      color: #146C43;
    }

    .paws-lead-popup__message[data-status="error"] {
      color: #A52424;
    }
  `;

  function closePopup(popup) {
    const closedUntilNext = Date.now() + CLOSED_DAYS * 24 * 60 * 60 * 1000;
    window.localStorage.setItem(STORAGE_KEY, String(closedUntilNext));
    popup.classList.remove('is-visible');
  }

  function ensureBrevoFrame() {
    let frame = document.querySelector('iframe[name="paws-brevo-submit-frame"]');
    if (frame) return frame;

    frame = document.createElement('iframe');
    frame.name = 'paws-brevo-submit-frame';
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    frame.style.cssText = 'position:absolute;width:1px;height:1px;border:0;clip:rect(0 0 0 0);clip-path:inset(50%);overflow:hidden;';
    document.body.appendChild(frame);
    return frame;
  }

  function submitBrevoForm(email, extraFields = {}) {
    if (!BREVO_FORM_ACTION) return false;

    ensureBrevoFrame();

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = BREVO_FORM_ACTION;
    form.target = 'paws-brevo-submit-frame';
    form.acceptCharset = 'UTF-8';
    form.style.display = 'none';

    const fields = {
      EMAIL: email,
      email_address_check: '',
      locale: 'es',
      ...extraFields
    };

    Object.keys(fields).forEach((name) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    window.setTimeout(() => form.remove(), 1000);
    return true;
  }

  function createPopup() {
    const style = document.createElement('style');
    style.textContent = styles;
    document.head.appendChild(style);

    const popup = document.createElement('div');
    popup.className = 'paws-lead-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'paws-lead-popup-title');

    popup.innerHTML = `
      <div class="paws-lead-popup__dialog">
        <button class="paws-lead-popup__close" type="button" aria-label="Cerrar popup">×</button>
        <p class="paws-lead-popup__eyebrow">Guía gratis para madres</p>
        <h2 class="paws-lead-popup__title" id="paws-lead-popup-title">Cuida sus manos antes de comprar calleras</h2>
        <p class="paws-lead-popup__copy">Recibe la guía de talla y cuidado de manos para barras, junto con avisos del Kit Guerrera PAWSGRIP.</p>
        <form method="post" action="/contact#paws-lead-popup" accept-charset="UTF-8">
          <input type="hidden" name="form_type" value="customer">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="contact[tags]" value="newsletter,paws-lead-popup,guia-cuidado-manos,brevo-list-8">
          <input type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;opacity:0;">
          <input class="paws-lead-popup__field" type="email" name="contact[email]" autocomplete="email" required placeholder="Tu email" aria-label="Tu email">
          <button class="paws-lead-popup__button" type="submit">Quiero la guía gratis</button>
          <p class="paws-lead-popup__message" role="status" aria-live="polite"></p>
        </form>
        <p class="paws-lead-popup__legal">Al dejar tu email aceptas recibir emails de PAWSGRIP con guías, novedades y avisos de lanzamiento. Puedes darte de baja cuando quieras.</p>
        <div class="paws-lead-popup__trust" aria-label="Garantías de suscripción">
          <span>✓ Sin spam</span>
          <span>✓ Baja en un clic</span>
        </div>
      </div>
    `;

    popup.addEventListener('click', (event) => {
      if (event.target === popup || event.target.closest('.paws-lead-popup__close')) {
        closePopup(popup);
      }
    });

    popup.querySelector('form').addEventListener('submit', async (event) => {
      event.preventDefault();

      const form = event.currentTarget;
      const button = form.querySelector('.paws-lead-popup__button');
      const message = form.querySelector('.paws-lead-popup__message');
      const email = form.querySelector('input[name="contact[email]"]').value;
      const company = form.querySelector('input[name="company"]').value;

      if (company) {
        window.localStorage.setItem(SUCCESS_KEY, 'true');
        popup.classList.remove('is-visible');
        return;
      }

      button.disabled = true;
      message.textContent = '';
      message.removeAttribute('data-status');

      try {
        if (BREVO_API_KEY) {
          await addContactToBrevo(email, LEADS_LIST_ID, { SOURCE: 'popup_guia_cuidado_manos' });
        } else if (BREVO_FORM_ACTION) {
          submitBrevoForm(email, { SOURCE: 'popup_guia_cuidado_manos' });
        } else {
          await fetch(form.action || '/contact', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'text/html' }
          });
        }

        window.localStorage.setItem(SUCCESS_KEY, 'true');
        message.dataset.status = 'success';
        message.textContent = 'Listo. Te llevamos a la página de confirmación.';
        window.setTimeout(() => {
          window.location.href = THANK_YOU_URL || '/';
        }, 700);
      } catch {
        message.dataset.status = 'error';
        message.textContent = 'No hemos podido guardar tu email. Inténtalo de nuevo en unos segundos.';
      } finally {
        button.disabled = false;
      }
    });

    document.body.appendChild(popup);
    return popup;
  }

  function bindBrevoForms() {
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!form || !form.classList) return;
      const isWaitlist = form.classList.contains('paws-waitlist__form');
      const isLeadGuide = form.classList.contains('paws-guide-lead-form');
      if (!isWaitlist && !isLeadGuide) return;

      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const emailField = form.querySelector('input[type="email"]');
      const productField = form.querySelector('input[name="contact[body]"]');
      const parent = form.parentElement;
      const success = parent && parent.querySelector('.paws-waitlist__success');
      const nextStep = parent && parent.querySelector('.paws-waitlist__next');

      if (!emailField || !emailField.value) return;
      if (button) button.disabled = true;

      const email = emailField.value;
      const noteValue = productField ? productField.value : '';
      const imageField = form.querySelector('input[name="paws_product_image"]');
      const urlField = form.querySelector('input[name="paws_product_url"]');
      const productImage = imageField ? imageField.value : '';
      const productUrl = urlField ? urlField.value : '';

      // UX optimista: mostrar éxito inmediatamente
      form.style.display = 'none';
      if (success) success.style.display = 'block';
      if (isWaitlist && nextStep) {
        window.setTimeout(() => { nextStep.style.display = 'block'; }, 400);
      }
      if (button) button.disabled = false;

      if (isLeadGuide && THANK_YOU_URL) {
        window.setTimeout(() => { window.location.href = THANK_YOU_URL; }, 1200);
      }

      if (window.PawsAnalytics && typeof window.PawsAnalytics.trackSimple === 'function') {
        window.PawsAnalytics.trackSimple('generate_lead', {
          lead_type: isLeadGuide ? 'lead_magnet' : 'availability_alert',
          location_id: isLeadGuide ? 'guide_landing' : 'product_waitlist'
        });
      }

      // Captura en background: Brevo API primero, fallback a Shopify contact
      (async () => {
        let brevoOk = false;
        const listId = isLeadGuide ? LEADS_LIST_ID : WAITLIST_LIST_ID;
        const attrs = {
          SOURCE: isLeadGuide ? 'landing_guia_cuidado_manos' : 'product_availability_alert',
          NOTE: noteValue,
          ...(isLeadGuide ? { WELCOME_STEP: 1 } : {})
        };

        if (BREVO_API_KEY) {
          brevoOk = await addContactToBrevo(email, listId, attrs);
          if (brevoOk && isWaitlist) {
            const { productName, variantName } = parseWaitlistNote(noteValue);
            sendBrevoTransactional(email, 29, {
              PRODUCT_NAME: productName || 'Calleras PAWSGRIP',
              VARIANT_NAME: variantName || '',
              PRODUCT_IMAGE: productImage,
              PRODUCT_URL: productUrl || 'https://pawsgrip.com/collections/calleras'
            });
          }
          if (brevoOk && isLeadGuide) {
            sendBrevoTransactional(email, 17, {});
          }
        } else if (BREVO_FORM_ACTION) {
          submitBrevoForm(email, { SOURCE: attrs.SOURCE, NOTE: noteValue });
          brevoOk = true;
        }

        // Siempre capturar en Shopify contact como backup (silencioso)
        if (!brevoOk) {
          try {
            const fd = new FormData(form);
            fd.set('contact[email]', email);
            await fetch('/contact', { method: 'POST', body: fd, headers: { Accept: 'text/html' } });
          } catch { /* silencioso */ }
        }
      })();
    });
  }

  function showPopup() {
    if (document.querySelector('.paws-lead-popup.is-visible')) return;
    const popup = document.querySelector('.paws-lead-popup') || createPopup();
    popup.classList.add('is-visible');
    const email = popup.querySelector('input[type="email"]');
    if (email) email.focus({ preventScroll: true });
  }

  window.setTimeout(showPopup, DELAY_MS);
  bindBrevoForms();

  window.addEventListener(
    'scroll',
    () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable > 0.35) showPopup();
    },
    { passive: true, once: true }
  );
})();
